import React, { useState, useEffect } from "react";
import styled from "styled-components";
import RoyalRank from "./rank";
import axios from "axios";
import RankingSelector from "./rankingSelector.jsx";

const DivBody = styled.div`
  min-height: 90vh;
  width: 100%;
  @media (min-width: 820px) {
    display: flex;
  }
`;

const DivMain = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const Body = () => {
  const [championData, setChampionData] = useState([]);
  const [aspirantData, setAspirantData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRank, setSelectedRank] = useState("champion"); // controle do ranking exibido
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://mochila.tapiocahut.com/royal-arena",
      );
      setChampionData(response.data.champion || []);
      setAspirantData(response.data.aspirant || []);
    } catch (error) {
      console.error("Erro ao carregar rankings:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const displayedData =
    selectedRank === "champion" ? championData : aspirantData;

  return (
    <DivBody>
      <DivMain>
        <RankingSelector selected={selectedRank} onChange={setSelectedRank} />
        <RoyalRank loading={loading} data={displayedData} />
      </DivMain>
    </DivBody>
  );
};

export default Body;
